var generalMixin = {
	filters: {
		toFixed: function (value) {
			return parseFloat(value).toFixed(2);
		},
	},
	methods: {
		/**
		 * Checks to see if an object is empty
		 * @param {any} object - object to check
		 * @returns {boolean}
		 */
		isEmpty: function (obj) {
			return Object.keys(obj).length === 0;
		},
		/**
		 * Returns true if the value is empty
		 * @param {any} value
		 */
		isNullOrEmpty: function (value) {
			return !value;
		},
		/**
		 * Set's the cookie, default 365 days
		 * @param {string} name Name of the cookie
		 * @param {any} value
		 * @param {number} days
		 */
		setCookie: function (name, value, days = 365) {
			var expires = '';
			if (days) {
				var date = new Date();
				date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
				expires = '; expires=' + date.toUTCString();
			}
			document.cookie = name + '=' + (value || '') + expires + '; path=/';
		},
		/**
		 * Get's the cookie
		 * @param {string} name Name of the cookie
		 */
		getCookie: function (name) {
			const nameEQ = name + '=';
			const ca = document.cookie.split(';');
			for (var i = 0; i < ca.length; i++) {
				var c = ca[i];
				while (c.charAt(0) == ' ') c = c.substring(1, c.length);
				if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
			}
			return null;
		},
		/**
		 * Deletes the cookie
		 * @param {string} name Name of the cookie
		 */
		eraseCookie: function (name) {
			document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
		},
		getById: function (id) {
			var el = document.getElementById(id);
			if (!el) {
				console.log(id + ' is not defined');
				return null;
				throw new ReferenceError();
			}
			return el;
		},
		/**
		 * Ensures the element or attribute exists
		 * @param {dom} element - a dom element e.g. from getElementById
		 */
		elementExists: function (element) {
			return element !== null && element !== undefined;
		},
		submitError: function () {
			setTimeout(function () {
				document.querySelector('.is-invalid').scrollIntoView();

				if (document.querySelector('.is-invalid').tagName == 'DIV') {
					if (document.querySelector('.is-invalid input')) {
						document.querySelector('.is-invalid input').focus();
					} else if (document.querySelector('.is-invalid select')) {
						document.querySelector('.is-invalid select').focus();
					} else {
						document.querySelector('.is-invalid textarea').focus();
					}
				} else {
					document.querySelector('.is-invalid').focus();
				}
			}, 10);
		},
	},
};
